export const SET_POP_DATA = 'SET_POP_DATA';

export type FocusedSectionAction = { type: string, data: any }
